/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { setEcgTypeOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getEcgTypeOptions() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const ecgTypeOptions = yield call([vitalsService, vitalsService.getEcgType])
    const { entity } = ecgTypeOptions
    yield put(setEcgTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getEcgTypeOptions() error: ${e}`))
  }
}

export function* getEcgTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getEcgTypeOptions)
}
